import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { NAV } from "@/lib/testIds";

export const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  const isDark = mounted && theme === "dark";

  return (
    <button
      type="button"
      data-testid={NAV.themeToggle}
      onClick={() => setTheme(isDark ? "light" : "dark")}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className="nav-icon-button relative inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-foreground/15 leading-none text-foreground transition-colors duration-300 hover:border-foreground/40 hover:bg-foreground/5"
    >
      <Moon
        size={16}
        className={`absolute block transition-opacity duration-300 ${
          isDark ? "opacity-0" : "opacity-100"
        }`}
      />
      <Sun
        size={16}
        className={`absolute block transition-opacity duration-300 ${
          isDark ? "opacity-100" : "opacity-0"
        }`}
      />
    </button>
  );
};

export default ThemeToggle;
